import React from "react";
import { useNavigate } from "react-router-dom";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  Paper,
  Menu,
  Tooltip,
} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const FeedbackSharing = () => {
  const navigate = useNavigate();

  //Go back to previous component
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="component-wrapper">
      <div className="component-title">
        <div className="flex-row-container">
          <div className="flex-row-custom-1">
            <span className="title-back-button" onClick={goBack}>
              <Tooltip title="Go Back" arrow placement="top">
                <ArrowBackIosIcon />
              </Tooltip>
            </span>

            <span>Feedback</span>
          </div>
        </div>
      </div>

      <div className="wrapper"></div>
    </div>
  );
};

export default FeedbackSharing;
